import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "cx-year-cell" }
const _hoisted_2 = {
  key: 0,
  class: "dp__marker_dot"
}

interface Props {
  yearValue: number,
  isActiveYear: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CxYearCell',
  props: {
    yearValue: {},
    isActiveYear: { type: Boolean }
  },
  setup(__props: any) {


const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.yearValue) + " ", 1),
    (_ctx.isActiveYear)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})